<template>
  <div>
    <vxe-form
        ref="xForm"
        title-align="right"
        title-width="150"
        :data="formData"
        :rules="formRules"
        @submit="submit"
    >
      <vxe-form-item span="24">
        <div class="block">
          <img src="~assets/images/newUser/zcyh.png"/>
          <span>注册用户：</span>
        </div>
      </vxe-form-item>
      <vxe-form-item span="24">
        <div style="display: flex;align-items: center">
          <div>
            <img v-if="userData.headimg == null" class="circleImg" src="~assets/images/common/head.png"/>
            <img v-else class="circleImg" :src="userData.headimg"/>
          </div>
          <div style="margin-left: 20px">
            <div style="display: flex;align-items: center;">
              <span style="font-size: 16px;">{{
                  userData.nickName ? userData.nickName : userData.loginName ? geTel(userData.loginName) : ''
                }}</span>
              <div style="display: flex; align-items: center; margin-left: 14px;"
                   @click="auditAuth(formData.auditStatus)">
                <img v-if="formData.auditStatus === 0" style="width: 100%; height: 100%"
                     src="@/assets/images/common/wrz.png"/>
                <img v-if="formData.auditStatus === 1" style="width: 100%; height: 100%"
                     src="@/assets/images/common/dsh.png"/>
                <img v-if="formData.auditStatus === 2" style="width: 100%; height: 100%"
                     src="@/assets/images/common/wtg.png"/>
                <img v-if="formData.auditStatus === 3" style="width: 100%; height: 100%"
                     src="@/assets/images/common/yrz.png"/>
                <img v-if="formData.auditStatus === 4" style="width: 100%; height: 100%"
                     src="@/assets/images/common/ysx.png"/>
              </div>
            </div>
            <Rate class="rate" v-model="userData.starLv" disabled style="margin-top: 5px;"></Rate>
          </div>
        </div>
      </vxe-form-item>
      <vxe-form-item title="注册手机号:" field="loginName" span="8">
        <template>
          <span>{{ userData.loginName }}</span>
        </template>
      </vxe-form-item>
      <vxe-form-item title="身份类型:" field="userCategoryStr" span="8">
        <template>
          <span v-if="!isEdit">{{ userData.tagsStr }}</span>
          <vxe-select
              v-else
              v-model="formData.userCategoryStr"
              placeholder="请选择"
              :options="userCategoryType"
              transfer
              multiple
              @change="clickUserCategory($event)"
          ></vxe-select>
        </template>
      </vxe-form-item>
      <vxe-form-item title="会员类型:" field="vipStr" span="8">
        <span>{{ userData.vipStr }}</span>
      </vxe-form-item>
      <vxe-form-item title="账号类型:" field="isTester" span="8">
        <span>{{ userData.isTester === 1 ? '内部' : '用户' }}</span>
      </vxe-form-item>
      <vxe-form-item title="用户来源:" field="sourceType" span="8">
        <span>{{ userData.sourceType | sourceType }}</span>
      </vxe-form-item>
      <vxe-form-item title="状态:" field="state" span="8">
        <span>{{ userData.state | state }}</span>
      </vxe-form-item>
      <vxe-form-item span="24">
        <div class="block">
          <img src="~assets/images/newUser/grxx.png"/>
          <span>个人信息：</span>
        </div>
      </vxe-form-item>
      <vxe-form-item title="身份证正面:" field="idcardFrontUrl" span="8">
        <div style="height: 58px; display: flex; align-items: center">
          <upload-img
              v-if="isEdit && (formData.auditStatus === 0 || formData.auditStatus === 2 || formData.auditStatus === 4 || (formData.auditStatus === 3 && formData.authSource === 3))"
              :row="formData" :fileKey="'idcardFrontUrl'" :width="58" :height="58"
              :initFile="formData.idcardFrontUrl" :isOcrIdCard="true" :isFront="true"
              @getOcrIdCard="getOcrIdCard"></upload-img>
          <div
              class="div-img"
              v-if="(!isEdit || formData.auditStatus === 1 || formData.auditStatus === 3 && formData.authSource !== 3) && formData.idcardFrontUrl">
            <viewer>
              <img :src="formData.idcardFrontUrl" width="58" height="58"/>
            </viewer>
          </div>
        </div>
      </vxe-form-item>
      <vxe-form-item title="身份证反面:" field="idcardBackUrl" span="16">
        <div style="height: 58px; display: flex; align-items: center">
          <upload-img
              v-if="isEdit && (formData.auditStatus === 0 || formData.auditStatus === 2 || formData.auditStatus === 4 || (formData.auditStatus === 3 && formData.authSource === 3))"
              :row="formData" :fileKey="'idcardBackUrl'" :width="58" :height="58"
              :initFile="formData.idcardBackUrl"></upload-img>
          <div class="div-img"
               v-if="(!isEdit || formData.auditStatus === 1 || formData.auditStatus === 3 && formData.authSource !== 3) && formData.idcardBackUrl">
            <viewer>
              <img :src="formData.idcardBackUrl" width="58" height="58"/>
            </viewer>
          </div>
        </div>
      </vxe-form-item>
      <vxe-form-item title="姓名:" field="realName" span="8">
        <template v-slot="scope">
          <vxe-input
              v-if="isEdit && (formData.auditStatus === 0 || formData.auditStatus === 2 || formData.auditStatus === 4)"
              v-model="formData.realName"
              placeholder="请输入姓名"
              @input="$refs.xForm.updateStatus(scope)"
          ></vxe-input>
          <span v-else>{{ formData.realName }}</span>
        </template>
      </vxe-form-item>
      <vxe-form-item title="身份证号:" field="idcardNum" span="8">
        <template v-slot="scope">
          <vxe-input
              v-if="isEdit && (formData.auditStatus === 0 || formData.auditStatus === 2 || formData.auditStatus === 4)"
              v-model="formData.idcardNum"
              placeholder="请输入身份证号"
              @input="$refs.xForm.updateStatus(scope)"
          ></vxe-input>
          <span v-bind:class="{ active: isEdit }" v-else>{{ formData.idcardNum }}</span>
        </template>
      </vxe-form-item>
      <vxe-form-item title="证件地址:" field="regAddr" span="8">
        <span v-if="!isEdit">{{ formData.regAddr }}</span>
        <vxe-input v-else v-model="formData.regAddr" placeholder="选填"></vxe-input>
      </vxe-form-item>
      <vxe-form-item title="性别:" field="sex" span="8">
        <span v-if="!isEdit">{{ formData.sex === 1 ? '男' : formData.sex === 0 ? '女' : '' }}</span>
        <Select v-else v-model="formData.sex">
          <Option v-for="(item, index) in sex_type" :value="item.value" :key="index">{{ item.label }}</Option>
        </Select>
      </vxe-form-item>
      <vxe-form-item title="邮箱:" field="email" span="8">
        <span v-if="!isEdit">{{ formData.email }}</span>
        <vxe-input v-else v-model="formData.email" placeholder="选填"></vxe-input>
      </vxe-form-item>
      <vxe-form-item span="24" v-if="formData.userCategoryStr && formData.userCategoryStr.indexOf('司机') > -1">
        <div class="block">
          <img src="~assets/images/newUser/jszxx.png"/>
          <span>驾驶证信息：</span>
        </div>
      </vxe-form-item>
      <vxe-form-item title="驾驶证正面:" field="drivingCardFrontUrl" span="8"
                     v-if="formData.userCategoryStr && formData.userCategoryStr.indexOf('司机') > -1">
        <div style="height: 58px; display: flex; align-items: center">
          <upload-img
              v-if="isEdit && formData.identityStatus !== 3 && formData.identityStatus !== 1"
              :row="formData"
              :fileKey="'drivingCardFrontUrl'"
              :width="58"
              :height="58"
              :initFile="formData.drivingCardFrontUrl"
              :isOcrDriving="true"
              :isFront="true"
              @getOcrDriving="getOcrDriving"
          ></upload-img>
          <div class="div-img"
               v-if="(isEdit && (formData.identityStatus === 3 || formData.identityStatus === 1) && formData.drivingCardFrontUrl) || (!isEdit && formData.drivingCardFrontUrl)">
            <viewer>
              <img :src="formData.drivingCardFrontUrl" width="58" height="58"/>
            </viewer>
          </div>
        </div>
      </vxe-form-item>
      <vxe-form-item title="驾驶证副页:" field="drivingCardSubpageUrl" span="16"
                     v-if="formData.userCategoryStr && formData.userCategoryStr.indexOf('司机') > -1">
        <div style="height: 58px; display: flex; align-items: center">
          <upload-img
              v-if="isEdit && formData.identityStatus !== 3 && formData.identityStatus !== 1"
              :row="formData"
              :fileKey="'drivingCardSubpageUrl'"
              :width="58"
              :height="58"
              :initFile="formData.drivingCardSubpageUrl"
              :isOcrDriving="true"
              @getOcrDriving="getOcrDriving"
          ></upload-img>
          <div class="div-img"
               v-if="(isEdit && (formData.identityStatus === 3 || formData.identityStatus === 1) && formData.drivingCardSubpageUrl) || (!isEdit && formData.drivingCardSubpageUrl)">
            <viewer>
              <img :src="formData.drivingCardSubpageUrl" width="80" height="80"/>
            </viewer>
          </div>
        </div>
      </vxe-form-item>
      <vxe-form-item title="驾驶证号:" field="driverCardNum" span="8"
                     v-if="formData.userCategoryStr && formData.userCategoryStr.indexOf('司机') > -1">
        <span v-if="!isEdit || formData.identityStatus === 1 || formData.identityStatus === 3">{{
            formData.driverCardNum
          }}</span>
        <vxe-input
            v-else-if="isEdit && (formData.identityStatus == null || formData.identityStatus === 0 || formData.identityStatus === 2 || formData.identityStatus === 4)"
            class="formInput" v-model="formData.driverCardNum" placeholder="请输入驾驶证号"
        ></vxe-input>
      </vxe-form-item>
      <vxe-form-item title="准驾车型:" field="driverModel" span="8"
                     v-if="formData.userCategoryStr && formData.userCategoryStr.indexOf('司机') > -1">
        <span
            v-if="!isEdit || formData.identityStatus === 1 || formData.identityStatus === 3">{{
            formData.driverModelText
          }}</span>
        <Select
            v-else-if="isEdit && (formData.identityStatus === null || formData.identityStatus === 0 || formData.identityStatus === 2 || formData.identityStatus === 4)"
            v-model="formData.driverModel"
        >
          <Option v-for="(item, index) in driver_model" :value="item.value" :key="index">{{ item.label }}
          </Option>
        </Select>
      </vxe-form-item>
      <vxe-form-item title="驾驶证发证机关:" field="issueAuthority" span="8"
                     v-if="formData.userCategoryStr && formData.userCategoryStr.indexOf('司机') > -1">
        <span v-if="!isEdit || formData.identityStatus === 1 || formData.identityStatus === 3">{{
            formData.issueAuthority
          }}</span>
        <vxe-input
            v-else-if="isEdit && (formData.identityStatus == null || formData.identityStatus === 0 || formData.identityStatus === 2 || formData.identityStatus === 4)"
            class="formInput"
            v-model="formData.issueAuthority"
            placeholder="请输入驾驶证发证机关"
        ></vxe-input>
      </vxe-form-item>
      <vxe-form-item title="驾驶证有效期自:" field="driverBeginTime" span="8"
                     v-if="formData.userCategoryStr && formData.userCategoryStr.indexOf('司机') > -1">
        <span v-if="!isEdit || formData.identityStatus === 1 || formData.identityStatus === 3">{{
            formData.driverBeginTime | timeFormatDate
          }}</span>
        <vxe-input
            v-else-if="isEdit && (formData.identityStatus === null || formData.identityStatus === 0 || formData.identityStatus === 2 || formData.identityStatus === 4)"
            class="formInput"
            type="date"
            v-model="formData.driverBeginTime"
            placeholder="请选择日期"
        ></vxe-input>
      </vxe-form-item>
      <vxe-form-item title="驾驶证有效期至:" field="driverExpireTime" span="8"
                     v-if="formData.userCategoryStr && formData.userCategoryStr.indexOf('司机') > -1">
        <span v-if="!isEdit || formData.identityStatus === 1 || formData.identityStatus === 3">{{
            formData.driverExpireTime | timeFormatDate
          }}</span>
        <vxe-input
            v-else-if="isEdit && (formData.identityStatus === null || formData.identityStatus === 0 ||formData.identityStatus === 2 || formData.identityStatus === 4)"
            class="formInput"
            type="date"
            v-model="formData.driverExpireTime"
            placeholder="请选择日期"
        ></vxe-input>
      </vxe-form-item>
      <vxe-form-item title="所驾驶车辆总重量:" field="weightType" span="8"
                     v-if="formData.userCategoryStr && formData.userCategoryStr.indexOf('司机') > -1">
        <span v-if="!isEdit">{{ formData.weightType | weightType }}</span>
        <Select v-else v-model="formData.weightType">
          <Option v-for="(item, index) in weight_type" :value="item.value" :key="index">{{ item.label }}</Option>
        </Select>
      </vxe-form-item>
      <vxe-form-item span="24" v-if="formData.userCategoryStr && formData.userCategoryStr.indexOf('司机') > -1">
        <div class="block">
          <img src="~assets/images/newUser/cyzgz.png"/>
          <span>从业资格证信息：</span>
        </div>
      </vxe-form-item>
      <vxe-form-item title="从业资格证:" field="qualificationUrl" span="8"
                     v-if="formData.userCategoryStr && formData.userCategoryStr.indexOf('司机') > -1">
        <div style="height: 58px; display: flex; align-items: center">
          <upload-img
              v-if="isEdit && formData.identityStatus !== 3 && formData.identityStatus !== 1"
              :row="formData"
              :fileKey="'qualificationUrl'"
              :width="58"
              :height="58"
              :initFile="formData.qualificationUrl"
          ></upload-img>
          <div class="div-img"
               v-if="(isEdit && (formData.identityStatus === 3 || formData.identityStatus === 1) && formData.qualificationUrl) || (!isEdit && formData.qualificationUrl)">
            <viewer>
              <img :src="formData.qualificationUrl" width="58" height="58"/>
            </viewer>
          </div>
        </div>
      </vxe-form-item>
      <vxe-form-item title="从业资格证号:" field="transportLicenseNum" span="8"
                     v-if="formData.userCategoryStr && formData.userCategoryStr.indexOf('司机') > -1">
        <div style="height: 58px; display: flex; align-items: center">
        <span v-if="!isEdit || formData.identityStatus === 1 || formData.identityStatus === 3">{{
            formData.transportLicenseNum
          }}</span>
          <vxe-input
              v-else-if="isEdit && (formData.identityStatus == null || formData.identityStatus === 0 || formData.identityStatus === 2 || formData.identityStatus === 4)"
              class="formInput"
              v-model="formData.transportLicenseNum"
              placeholder="请输入从业资格证号"
          ></vxe-input>
        </div>
      </vxe-form-item>
      <vxe-form-item title="从业资格证有效期至:" field="transportExpireTime" span="8"
                     v-if="formData.userCategoryStr && formData.userCategoryStr.indexOf('司机') > -1">
        <div style="height: 58px; display: flex; align-items: center">
        <span v-if="!isEdit || formData.identityStatus === 1 ||formData.identityStatus === 3">{{
            formData.transportExpireTime | timeFormatDate
          }}</span>
          <vxe-input
              v-else-if="isEdit && (formData.identityStatus === null || formData.identityStatus === 0 || formData.identityStatus === 2 || formData.identityStatus === 4)"
              class="formInput"
              type="date"
              v-model="formData.transportExpireTime"
              placeholder="请选择日期"
          ></vxe-input>
        </div>
      </vxe-form-item>
      <vxe-form-item align="right" span="24" style="margin-top: 20px" v-if="isEdit">
        <vxe-button style="width: 140px; border-radius: 5px" @click="cancel()">取消</vxe-button>
        <vxe-button type="submit" status="primary" style="width: 140px; border-radius: 5px">保存</vxe-button>
      </vxe-form-item>
      <vxe-form-item align="right" span="24" style="margin-top: 20px" v-if="!isEdit && isHavePermission('userManage:edit')">
        <vxe-button status="primary" style="width: 140px; border-radius: 5px" @click="isEdit = true">编辑</vxe-button>
      </vxe-form-item>
    </vxe-form>
    <vxe-modal v-model="perAuthVisible" title="个人认证" width="1000" height="700" resize
               position="center">
      <per-authentication ref="perAuth" @close="perAuthVisible = false" :isClient="true"></per-authentication>
    </vxe-modal>
  </div>
</template>
<script>
import $api from "@/apiProvider";
import perAuthentication from "@/views/account/perAuthentication";
import UploadImg from "@/components/common/UploadImg";
import getAuthOrization from "@/mixin/getAuthOrization";

export default {
  props: {
    userData: Object,
  },
  components: {perAuthentication, UploadImg},
  mixins: [getAuthOrization],
  data() {
    return {
      perAuthVisible: false,
      userCategoryType: [{
        label: '货主',
        value: '货主'
      },
        {
          label: '船东',
          value: '船东'
        },
        {
          label: '司机',
          value: '司机'
        },
        {
          label: '代理',
          value: '代理'
        },
        {
          label: '船员',
          value: '船员'
        },
        {
          label: '供应商',
          value: '供应商'
        },
        {
          label: '其他',
          value: '其他'
        }
      ],
      formData: {
        nickname: 'XXXXX',
        auditStatus: 0,
        userCategoryStr: []
      },
      formRules: {
        realName: [{required: true, message: "请输入姓名"}],
        idcardNum: [{required: true, message: "请输入身份证号"}],
        userCategoryStr: [{required: true, message: "请选择身份类型"}],
      },
      isEdit: false,
      driver_model: [],
      weight_type: [
        {
          label: "大于4.5吨",
          value: 1,
        },
        {
          label: "小于等于4.5吨",
          value: 2,
        },
      ],
      sex_type: [
        {
          label: "女",
          value: 0,
        },
        {
          label: "男",
          value: 1,
        },
      ],
      userId: null
    }
  },
  filters: {
    sourceType(val) {
      if (val === 2) {
        return '主动注册';
      }
      if (val === 1) {
        return '后台添加';
      }
      if (val === 3) {
        return '用户邀请';
      }
      if (val === 4) {
        return '微信公众号';
      }
      if (val === 5) {
        return '微信小程序';
      }
      if (val === 6) {
        return '代客户创建';
      }
    },
    weightType(val) {
      if (val != null) {
        if (val === 1) {
          return "大于4.5吨";
        }
        if (val === 2) {
          return "小于等于4.5吨";
        }
      }
    },
    state(val) {
      if (val === 0) {
        return '禁用';
      }
      if (val === 1) {
        return '启用';
      }
      if (val === 2) {
        return '禁用';
      }
      if (val === 3) {
        return '待注销';
      }
      if (val === 4) {
        return '已注销';
      }
    },
  },
  watch: {
    userData: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        if (val.id) {
          this.formData = val.userGyl;
          this.formData.auditStatus = val.authStatus ? val.authStatus : 0;
          if (val.userGyl) {
            this.userId = val.userGyl.id;
          }
        }
      }
    }
  },
  created() {
    this.getDict(40500, "driver_model");
  },
  methods: {
    geTel(tel) {
      let reg = /^(\d{3})\d{4}(\d{4})$/;
      return tel.replace(reg, "$1****$2");
    },
    getOcrIdCard(data) {
      if (data.xingming) {
        this.$set(this.formData, 'realName', data.xingming);
      }
      if (data.xingbie) {
        this.$set(this.formData, 'sex', data.xingbie === '男' ? 1 : 0);
      }
      if (data.shenfenzhenghaoma) {
        this.$set(this.formData, 'idcardNum', data.shenfenzhenghaoma);
      }
      if (this.formData.userCategoryStr && this.formData.userCategoryStr.indexOf('司机') > -1) {
        this.$set(this.formData, 'driverCardNum', data.shenfenzhenghaoma);
        this.$set(this.formData, 'transportLicenseNum', data.shenfenzhenghaoma);
      }

      if (data.zhuzhi) {
        this.$set(this.formData, 'regAddr', data.zhuzhi);
      }
    },
    clickUserCategory(val) {
      this.$forceUpdate();
    },
    async submit() {
      let obj = Object.assign({}, this.formData);
      if (obj.userCategoryStr) {
        obj.userCategoryStr = obj.userCategoryStr.toString();
      }

      if (obj.businessExpireTime) {
        obj.businessExpireTime = this.$utils.timestamp(obj.businessExpireTime);
      }
      if (obj.idCardExpireTime) {
        obj.idCardExpireTime = this.$utils.timestamp(obj.idCardExpireTime);
      }
      if (obj.driverBeginTime) {
        obj.driverBeginTime = this.$utils.timestamp(obj.driverBeginTime);
      }
      if (this.formData.driverExpireTime) {
        obj.driverExpireTime = this.$utils.timestamp(obj.driverExpireTime);
      }
      if (obj.transportExpireTime) {
        obj.transportExpireTime = this.$utils.timestamp(obj.transportExpireTime);
      }

      obj.userIdClient = this.userData.id;

      let res = await $api.gcdUser.request("updateUserInfoClient", obj);
      if (res.status === 1) {
        this.$Message.success('保存成功');
        this.isEdit = false;
        this.$emit('afterSave');
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    auditAuth(val) {
      this.perAuthVisible = true;
      this.$nextTick(() => {
        this.$refs.perAuth.init(this.userData.id);
      })
    },
    cancel() {
      this.$refs.xForm.clearValidate();
      this.isEdit = false;
      this.$emit('afterSave');
    },
    async getDict(code, key) {
      let res = await $api.dict.get("searchDic", {
        parentcode: code,
      });
      if (res.status === 1) {
        let arr = [];
        let data = res.data;
        data.map((i) => {
          arr.push({
            label: i.dictText,
            value: i.dictCode,
          });
        });
        this[key] = arr;
      } else {
        this.$XModal.message(res.message);
      }
    },
    getOcrDriving(data) {
      if (data.zhenghao) {
        this.$set(this.formData, 'driverCardNum', data.zhenghao);
      }
      if (data.zhunjiachexing) {
        let driverModel = null;
        this.driver_model.map(i => {
          if (i.label === data.zhunjiachexing) {
            driverModel = i.value;
          }
        })
        this.$set(this.formData, 'driverModel', driverModel);
      }
      if (data.fazhengdanwei) {
        this.$set(this.formData, 'issueAuthority', data.fazhengdanwei);
      }
      if (data.youxiaoqishiriqi) {
        let date = this.insertStr(data.youxiaoqishiriqi, 4, '-');
        date = this.insertStr(date, 7, '-');
        this.$set(this.formData, 'driverBeginTime', date);
      }
      if (data.shixiaoriqi) {
        let date = this.insertStr(data.shixiaoriqi, 4, '-');
        date = this.insertStr(date, 7, '-');
        this.$set(this.formData, 'driverExpireTime', date);
      }
    },
    insertStr(source, start, newStr) {
      return source.slice(0, start) + newStr + source.slice(start)
    },
  }
}
</script>
<style scoped>
.rate >>> .ivu-rate-star-full:before {
  color: red;
}

.block {
  display: flex;
  align-items: center;
}

.block span {
  margin-left: 5px;
  font-size: 15px;
  color: #438df3;
}
</style>